<template>
  <Auth />
</template>

<script>
import Auth from "./Auth.vue";

export default {
  name: "Login",
  components: { Auth },
};
</script>
